import React from "react";

const CustomFormContext = React.createContext();

export { CustomFormContext };